import { render, staticRenderFns } from "./SaveNow.vue?vue&type=template&id=56e8bb90"
import script from "./SaveNow.vue?vue&type=script&lang=js"
export * from "./SaveNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports